// Mechanic Tools Icon - Ratchet and Socket style
export const MechanicTools = ({ className = "w-6 h-6", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    {/* Ratchet handle */}
    <path d="M3 21l6-6" strokeWidth="2.5" />
    <path d="M9 15l2-2" strokeWidth="2" />
    
    {/* Ratchet head */}
    <circle cx="12.5" cy="11.5" r="2.5" strokeWidth="2" />
    <path d="M14 10l1-1" strokeWidth="1.5" />
    
    {/* Socket wrench */}
    <rect x="15" y="3" width="6" height="8" rx="1" strokeWidth="1.5" />
    <line x1="15" y1="5" x2="21" y2="5" strokeWidth="1" />
    <line x1="15" y1="7" x2="21" y2="7" strokeWidth="1" />
    <line x1="15" y1="9" x2="21" y2="9" strokeWidth="1" />
    
    {/* Socket hex opening */}
    <path d="M17 12v2l1 1h2l1-1v-2" strokeWidth="1.5" />
    
    {/* Small wrench detail */}
    <path d="M4 4l3 3" strokeWidth="2" />
    <circle cx="3" cy="3" r="1.5" fill="currentColor" />
  </svg>
);

export default MechanicTools;
